import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import InviteModal from "../Components/InviteModal";
import api from '../api';

const WorkSpaceInvite = () => {
  const { workspace_code } = useParams()
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [modalState, setModalState] = useState({
    isOpen: false,
    message: '',
    isSuccess: false
  });


  const processInvite = async () => {
    if (!token) {
      setModalState({
        isOpen: true,
        message: '유효하지 않은 초대 링크입니다.',
        isSuccess: false
      });
      return;
    }

    try {
      const response = await api.get(`/workspace/invite/${workspace_code}?token=${token}`);

      setModalState({
        isOpen: true,
        message: response.data.message,
        isSuccess: true
      });
    } catch (error) {
      setModalState({
        isOpen: true,
        message: error.response?.data?.message || '유효하지 않거나 만료된 링크입니다.',
        isSuccess: false
      });
    } return
  };

  useEffect(() => {
    processInvite();
  }, []);

  const handleModalClose = () => {
    setModalState(prev => ({ ...prev, isOpen: false }));
    if (modalState.isSuccess) {
      window.location.href = `${process.env.REACT_APP_APP_DOMAIN}/workspaces`
    } else {
      navigate('/');
    }
  };

  return (
    <InviteModal
      isOpen={modalState.isOpen}
      message={modalState.message}
      onClose={handleModalClose}
    />
  );
};

export default WorkSpaceInvite;